import eventBus from 'widgets/toolbox/eventBus';
import { getJSONByUrl } from 'widgets/toolbox/ajax';

/**
 * @description taken from SFRA integration
 * @todo in case if product option will be implemented, this functionality shall be refactored
 * @param {Object} selectElement selected element for option
 *
function monetateUpdateWarranty(selectElement) {
    var warrantyType = selectElement.data('monetatewarranty');
    var selectedProduct = window.monetateData.productDetails[0];
    var selectedWarrantyProductObject = {
        productId: warrantyType
    };
    var productToAdd = [selectedProduct];
    var firstOptionIsSelected = selectElement.find('option').first().is(':selected'); // warranty with zero value
    if (!firstOptionIsSelected) {
        productToAdd.push(selectedWarrantyProductObject);
    }
    window.monetateQ.push(['setPageType', window.monetateData.setPageType]);
    if (window.monetateData.addCartRows && window.monetateData.addCartRows.length != 0) window.monetateQ.push(['addCartRows', window.monetateData.addCartRows]);
    window.monetateQ.push(['addBreadcrumbs', window.monetateData.pdpBreadCrumbs]);
    window.monetateQ.push(['addProductDetails', productToAdd]);
    window.monetateQ.push(['trackData']);
}
*/

/**
 * @description Tracking pages which have type: "main", "cart", "login", "account", "shipping", "billing", "checkout", "checkoutLogin", "orderstatus", "wishlist", "signup"
* @param {string} pageType track page type
*/
function trackGeneralPage(pageType) {
    if (pageType) {
        window.monetateData.setPageType = pageType;
    }
    window.monetateQ.push(['setPageType', window.monetateData.setPageType]);
    if (window.monetateData.addCartRows && window.monetateData.addCartRows.length !== 0) {
        window.monetateQ.push(['addCartRows', window.monetateData.addCartRows]);
    }
    if (window.monetateData.setPageType === 'product') {
        window.monetateData.breadCrumbs = window.monetateData.pdpBreadCrumbs;
    }
    if (window.monetateData.breadCrumbs) {
        window.monetateQ.push(['addBreadcrumbs', window.monetateData.breadCrumbs]);
    }
    if (window.monetateData.productDetails) {
        window.monetateQ.push(['addProductDetails', window.monetateData.productDetails]);
    }
    window.monetateQ.push(['trackData']);
}

eventBus.on('monetate.track.page', (widget) => {
    const pageType = widget.data('monetate-page-type') || 'other';

    trackGeneralPage(pageType);
});

// checkout
let actualPage = window.monetateData.setPageType || '';
/**
 * @param {string} page page type checking
 */
function checkCheckoutPages(page) {
    var checkoutStage = page || window.location.search.split('stage=')[1];
    var pageType = 'undefined';
    if (checkoutStage) {
        switch (checkoutStage) {
            case 'shipping':
                pageType = 'shipping';
                break;
            case 'billing':
                pageType = 'billing';
                break;
            case 'summary':
                pageType = 'checkout';
                break;
            default:
                pageType = checkoutStage;
        }
        // run call only if stage was changed
        if (pageType !== actualPage) {
            trackGeneralPage(pageType);
            actualPage = pageType;
        }
    }
}

eventBus.on('monetate.track.checkout.step', checkCheckoutPages);

/**
 * @description Minicart update
 * @param {array} cartRowsJson
 */
function updateMinicart(cartRowsJson) {
    window.monetateData.addCartRows = cartRowsJson;
    if (['search', 'index'].indexOf(window.monetateData.setPageType) !== -1) {
        window.monetateData.trackPLPPage();
    } else if (window.monetateData.setPageType === 'category') {
        window.monetateData.trackCLPPage();
    } else if (window.monetateData.setPageType === 'product') {
        /**
         * @description taken from SFRA integration
         * @todo in case if product options will be implemented, should be refactored
        var $productWarranty = $('.js-monetate-warranty');
        if ($productWarranty.length > 0) {
            $productWarranty = $productWarranty.first();
            monetateUpdateWarranty($productWarranty);
        } else {
            trackGeneralPage();
        }
        */
        trackGeneralPage();
    } else if (window.monetateData.setPageType === 'other') {
        window.monetateData.trackUnknownPage();
    } else if (window.monetateData.setPageType === 'cart') {
        trackGeneralPage('cart');
    } else {
        trackGeneralPage();
    }
}

eventBus.on('minicart.updated', (cart) => {
    updateMinicart(cart.monetateBasket);
});

eventBus.on('product.added.to.cart', (cart) => {
    updateMinicart(cart.monetateBasket);
});

eventBus.on('cart.updated', (cart) => {
    updateMinicart(cart.monetateBasket);
});

// product swatchers
let oldProductID = window.monetateData.currentProductId;

function updateProductVariation(selectedProduct) {
    if (selectedProduct.id !== '' && oldProductID !== selectedProduct.id) {
        oldProductID = selectedProduct.id;

        window.monetateData.setPageType = 'product';
        window.monetateData.currentProductId = selectedProduct.id;
        window.monetateData.prevProductId = window.monetateData.prevProductId || '';

        window.monetateQ.push(['setPageType', window.monetateData.setPageType]);

        if (window.monetateData.addCartRows && window.monetateData.addCartRows.length !== 0) {
            window.monetateQ.push(['addCartRows', window.monetateData.addCartRows]);
        }

        if (window.monetateData.productDetails.length === 1) {
            window.monetateQ.push(['addBreadcrumbs', selectedProduct.monetate.pdpBreadCrumbs]);
            window.monetateData.productDetails = selectedProduct.monetate.productDetails;
            window.monetateQ.push(['addProductDetails', window.monetateData.productDetails]);
            window.monetateQ.push(['trackData']);
        }
    }
}

eventBus.on('monetate.variation.select', (product) => {
    updateProductVariation(product);
});

/**
 * @description taken from SFRA integration
 * @todo in case if product options will be implemented, should be refactored
$('.js-monetate-warranty').on('change', function () {
    monetateUpdateWarranty($(this));
});
*/

// show more button
let monetateLoadMoreProducts = []; // save loaded list of IDs
if (window.monetateData.addProducts) {
    monetateLoadMoreProducts = monetateLoadMoreProducts.concat(window.monetateData.addProducts);
}

eventBus.on('monetate.loadmore', (url) => {
    var showMoreUrl = url.replace('Search-UpdateGrid?', 'Monetate-UpdateGrid?');

    getJSONByUrl(showMoreUrl, {}).then((response) => {
        response.productIds.forEach((product) => {
            monetateLoadMoreProducts.push(product.productID);
        });

        if (monetateLoadMoreProducts) {
            window.monetateQ.push(['addProducts', monetateLoadMoreProducts]);
        }
        if (response.breadCrumbs) {
            window.monetateQ.push(['addBreadcrumbs', response.breadCrumbs]);
        }
        window.monetateQ.push(['setPageType', window.monetateData.setPageType]);

        if (response.categories) {
            window.monetateQ.push(['addCategories', [response.categories]]);
        }

        window.monetateQ.push(['trackData']);
    });
});

eventBus.on('monetate.filter.apply', (url) => {
    var selectedUrl = url.replace('Search-ShowAjax?', 'Monetate-ShowAjax?');
    var monetateProducts = [];

    getJSONByUrl(selectedUrl, {}).then((response) => {
        window.monetateData.addProducts = [];
        response.productIDs.forEach((productID) => {
            monetateProducts.push(productID);
        });

        if (window.monetateData.addProducts) {
            window.monetateQ.push(['addProducts', monetateProducts]);
        }
        if (response.breadCrumbs) {
            window.monetateQ.push(['addBreadcrumbs', response.breadCrumbs]);
        }
        window.monetateQ.push(['setPageType', window.monetateData.setPageType]);

        if (response.categories) {
            window.monetateQ.push(['addCategories', [response.categories]]);
        }

        window.monetateQ.push(['trackData']);
    });
});

eventBus.on('monetate.sort.apply', (url) => {
    var filterUrl = url.replace('Search-ShowAjax?', 'Monetate-ShowAjax?');
    var monetateProducts = [];

    getJSONByUrl(filterUrl, {}).then((response) => {
        response.productIDs.forEach((productID) => {
            monetateProducts.push(productID);
        });

        if (monetateProducts) {
            window.monetateQ.push(['addProducts', monetateProducts]);
        }
        if (response.breadCrumbs) {
            window.monetateQ.push(['addBreadcrumbs', response.breadCrumbs]);
        }
        window.monetateQ.push(['setPageType', window.monetateData.setPageType]);

        if (response.categories) {
            window.monetateQ.push(['addCategories', [response.categories]]);
        }

        window.monetateQ.push(['trackData']);
    });
});

eventBus.on('monetate.track.account.create', () => {
    window.monetateQ.push(['trackEvent', ['accountCreated']]);
});

eventBus.on('monetate.track.newsletter.signup', () => {
    window.monetateQ.push(['trackEvent', ['newsletterSignUp']]);
});
